<script lang="ts" setup>
import visitJapanVideo from '@/assets/animations/visit-japan.mp4';

const { isMobile } = useWindowResize();
const { trackEvent } = useGtm();
const profileStore = useProfileStore();

onMounted(() => {
	trackEvent({
		event: GTM_EVENT_NAME.VIEW_VISITING_JAPAN_SUCCESS,
		user_id: profileStore.profileId,
	});
});
</script>

<template>
	<div class="visit-japan-page">
		<div class="form-section">
			<div v-if="!isMobile" class="video-container">
				<video id="visit-japan-video" autoplay loop muted playsinline>
					<source :src="visitJapanVideo" type="video/mp4" />
					Your browser does not support HTML5 video.
				</video>
			</div>
			<div class="form-container">
				<JapanDiscoveryForm />
			</div>
		</div>
		<JapanEventsSection class="discovery-section" />
	</div>
</template>

<style lang="scss" scoped>
.visit-japan-page {
	display: flex;
	flex-direction: column;
}

.form-section {
	position: relative;
	height: calc(100dvh - 80px);
	box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
	backdrop-filter: blur(25px);

	// Mobile-only overrides to avoid nested scroll and viewport unit quirks on iOS
	@include media-query-max(mobile) {
		height: auto;
	}

	.video-container {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: rem(448);
		background: colors-get(base, black);

		#visit-japan-video {
			width: 100%;
			height: 100%;
			object-fit: cover;
			opacity: 0.5;
		}
	}

	.form-container {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		overflow-y: auto;
		padding: spacings-get(8) spacings-get(10);
		display: flex;
		align-items: flex-start;
		justify-content: flex-end;

		// Mobile-only overrides to avoid nested scroll and viewport unit quirks on iOS
		@include media-query-max(mobile) {
			position: static;
			height: auto;
			overflow: visible;

			:deep(.button-container) {
				padding-bottom: spacings-get(8);
			}
		}
	}
}

.discovery-section {
	padding-bottom: rem(152);
}
</style>
